/**
 * SD: Sicherheitsnetz für den Warenkorb-Drawer.
 * Nach dem ersten "Add to cart" zeigte der Drawer in manchen Browsern noch "Your cart is empty",
 * obwohl die Bubble am Korb schon eine Zahl zeigte (Horizon füllt den leeren Drawer über eine
 * View Transition, die nicht überall greift). Ist der Drawer leer, die Bubble aber nicht,
 * wird sein Inhalt hier frisch vom Server geladen – nach jedem Hinzufügen und beim Öffnen.
 */
import { sectionRenderer } from '@theme/section-renderer';

const SECTION_ID = 'cart-drawer-section';

const needsRefresh = () => {
  const drawerIsEmpty = document.querySelector('#cart-drawer [data-cart-drawer-empty]') !== null;
  const count = parseInt(document.querySelector('.cart-bubble__text-count')?.textContent ?? '0', 10) || 0;
  return drawerIsEmpty && count > 0;
};

const refresh = () => {
  if (!needsRefresh()) return;
  sectionRenderer
    .renderSection(SECTION_ID, { cache: false, mode: 'hydration', injectStylesheet: true })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[sd-cart] Refresh failed:', error);
    });
};

document.addEventListener('shopify:cart:lines-update', (/** @type {Event & {promise?: Promise<unknown>}} */ event) => {
  // Horizon hat dann Zeit, selbst zu aktualisieren; erst danach prüfen
  Promise.resolve(event.promise)
    .then(() => setTimeout(refresh, 600))
    .catch(() => {});
});

document.addEventListener('theme-drawer:open', refresh);
